<template>
  <div>
    <dingApprovalDetail v-if="accessMode === 2" />
    <template v-if="accessMode === 1">
      <collectionDetails v-if="type === 'approval'" :params="params" />
      <withhold v-if="type === 'widthhold'" :params="params" />
    </template>
  </div>
</template>
<script>
import collectionDetails from './collectionDetails.vue'
import dingApprovalDetail from './dingApprovalDetail.vue'
import withhold from './withhold.vue'

export default {
  components: {
    dingApprovalDetail,
    collectionDetails,
    withhold,
  },
  data() {
    return {
      type: '',
      params: {},
    }
  },
  created() {
    this.accessMode = ''
    if (this.$route.query.accessMode) {
      this.accessMode = Number(this.$route.query.accessMode)
    }

    this.type = this.$route.query.type
    this.params = this.$route.query
  },
}
</script>
<style scoped lang=""></style>
